import React, { useEffect, useRef } from 'react';
import widgetRender from './bei-light';

function test2(data, action) {
  // json parametres de la viz
  const widgetProperties_US342 = {
    generalProperties: {
      chartType: 'barchart', // barchart, pie, linechart
      orientation: 'horizontal', // horizontal, vertical (for XY axis chart)
      direction: 'standard', // standard, opposite
      margin: { top: 0, right: 140, bottom: 30, left: 80 },
      size: { width: '100%', height: '100%' },
      minSize: { width: 200, height: 200 },
      minPlotSize: { width: 100, height: 100 },
      activeClipPath: false,
      errorMsg: 'lorem ipsum'
    },
    detailProperties: {
      dataAggregation: false,
      dimensionFields: ['overvaluationReason', 'capitalStructure'],
      dimensionFieldsDatatype: ['text', 'text'],
      dimensionFieldsLabel: ['overvaluationReason', 'capitalStructure'],
      dimensionFieldsFormat: null,
      dimensionFieldsCustomSort: [null],
      dimensionFieldsSortOrder: [null],
      multiDimensionStyle: 'stacked', // grouped, stacked, diverging, bullet (for bullet & diverging multiDimensionStyle , 2nd axis must have 2 values max !!!)
      calculationFields: ['count'],
      calculationFieldsLabel: ['count'],
      calculationFieldsDatatype: ['number'],
      calculationFieldsFormat: ['.2'],
      calculationFieldsAdjustPct: false,
      styles: {
        themeScheme: 'beiLightTheme',
        colors: {
          defaultColor: '#002380',
          defaultStrokeColor: '#002380',
          defaultFillColor: '#002380',
          dimensionField: ['capitalStructure'],
          dimensionFieldSortOrder: null,
          dimensionFieldCustomOrder: null,
          dimensionScaleMode: ['categorical'], // categorical, continous
          scaleType: ['scaleOrdinal'], // scaleLinear, scaleSequential, scaleTreshold, scaleOrdinal
          interpolator: null,
          scheme: ['#231F20', '#BB4430', '#7EBDC2', '#F3DFA2', '#EFE6DD'],
          schemeType: 'colorArray' // colorArray, colorGradientArray
        },
        textures: {
          active: false,
          defaultTexture: ''
        }
      },
      XYChart: {
        includeOrigin: true, // used for barchart / linechart
        linearGridline: false,
        categoricalGridline: false,
        linearAxis: false,
        linearAxisLine: false,
        linearAxisLabel: false,
        linearAxisLabelFormat: '.0%',
        linearAxisTick: false,
        linearAxisMinMaxExtendFactor: [1, 1],
        linearAxisTicksNumber: 3,
        categoricalAxis: true,
        categoricalAxisLabel: true,
        categoricalAxisTick: false,
        categoricalAxisLabelFormat: '%b %e',
        categoricalAxisLabelHPadding: 0,
        categoricalAxisLabelVPadding: 10,
        categoricalAxisLabelTextWrapWidth: 200,
        categoricalAxisLabelTextWrapLineHeight: 1.2,
        categoricalAxisLabelTextAnchor: 'middle',
        stackOffset: 'stackOffsetExpand',
        barPadding: 0.4, // value between 0 and 1
        barRadius: 0, // value in px
        barRadiusPosition: 'all', // all, top, bottom
        barGroupPadding: 0.7, // value between 0 and 1
        barBandwithReduction: 0
      },
      axis: {
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: '200',
        color: '#979797',
        altColor: '#000000',
        labelColor: '#65676a',
        tickSize: 0,
        padding: 0,
        lineWidth: 0
      },
      gridline: {
        padding: -10,
        showExtend: true,
        dashArray: '10 10',
        width: 0.5,
        color: '#979797',
        altColor: '#000000',
        opacity: 0.8
      },
      title: {
        visible: false,
        text: null,
        hPosition: 'left',
        vPosition: 'top',
        hPadding: 20,
        vPadding: 10,
        alignment: 'center',
        fontFamily: 'Montserrat',
        color: '#535353',
        fontSize: '18px',
        fontWeight: '300',
        textAnchor: 'middle',
        SVG:
          "<text style='text-anchor:start'><tspan dy='0.7em'>OVERVIEW OF CAPITAL STRUCTURE</tspan></text>"
      },
      label: {
        visible: false,
        text: '[count]',
        color: '#535353',
        position: 'center', // top, bottom
        vPadding: 0,
        relativePosition: 'outside', // inside or outside shape element
        fontSize: '14px',
        textAnchor: 'middle',
        altTextAnchor: 'end'
      },
      legend: {
        type: 'colorScheme', // manual, data, dimension, measure
        scaleMode: 'categorical', // null, categorical, continous
        marker: 'square', // square, roundedSquare, circle, line
        markerSize: 14,
        text: null,
        orientation: 'vertical',
        hPosition: 'right',
        vPosition: 'center',
        hPadding: 20,
        vPadding: 0,
        alignment: 'center',
        fontFamily: 'Montserrat',
        padding: 0,
        color: '#535353',
        fontSize: '12px',
        fontWeight: '400',
        fontStyle: 'normal',
        textAnchor: 'start',
        blockPadding: 20,
        maxBlockPerRow: 5,
        minBlockSize: 120,
        SVG:
          "<g class='element'><text dy='0.9em'><tspan>[analystName] </tspan></text></g>",
        // 'SVG' : null,
        variableFormat: {
          cout: {
            datatype: 'number',
            formatOut: '$,.2d',
            removeFormatPctSign: false
          },
          __pct__: {
            datatype: 'number',
            formatOut: '.1~%',
            removeFormatPctSign: false
          }
        }
      },
      tooltip: {
        active: true,
        hPosition: 'shape', // shape, mouse, fixe
        vPosition: 'shape',
        hRelPosition: 'center',
        vRelPosition: 'up',
        // 'column' : ['cout','etp_contractuel','etp_ecart'],
        // 'columnSuffix' : [' ETP absence',' ETP contractuel',' ETP par rapport au indirect'],
        lineSeparator: true,
        fontFamily: 'Montserrat',
        padding: 0,
        color: '#535353', // '#FFFFFF'
        fontSize: '15px',
        fontWeight: '400',
        textAnchor: 'start',
        backgroundColor: '#ffffff', // '#535353',
        SVG:
          "<g><g><line x1='14' x2='14' y1='10' y2='70' style='stroke : [shapeColor];stroke-width: 2' /></g><text x='10' y='14' dy='0.7em'><tspan x='25' y='20'>Capital Structure : [capitalStructure]</tspan><tspan x='25' y='62'>Value : [count]</tspan></text></g>",
        variableFormat: {
          date: { datatype: 'date', formatIn: '%d/%m/%y', formatOut: '%B %e' }
        },
        tooltipSpecificFn: null
      },
      animation: {
        active: true,
        duration: 600,
        delay: 0,
        incrementalDelay: 0,
        ease: 'easeCubic' // default : easeCubic, easeLinear, easeBounce, easeElastic, easeExp, easeCircle
      },
      events: {
        mouseover: true,
        click: false
      }
    },
    contextualProperties: {
      tagId: 'ChartCapitalStructure',
      dataIn: data,
      dataOut: null,
      d3viz: {
        dom: { viz: null, gridline: null, plot: null, axis: null, title: null },
        axis: {
          x: null,
          y: null,
          x2: null,
          y2: null,
          color: null,
          texture: null
        },
        barchart: { bandwidth: null }
      }
    }
  };

  widgetRender(widgetProperties_US342, action);
}

const ChartCapitalStructure = ({ data, loading, error }) => {
  const d3svg = useRef(false);

  /*   useEffect(() => {
    }, [loading]); */

  useEffect(() => {
    if (d3svg.current && data) {
      const cnt = data.length;
      if (cnt !== 0) {
        test2(data, 'init');
      }
    } else d3svg.current = true;
  }, [data]);

  return (
    <>
      <div
        ref={d3svg}
        id="ChartCapitalStructure"
        role="img"
        style={{ width: '100%', height: '300px' }}>
        {loading && <h4>Loading...</h4>}
        {error && <h4>{error}</h4>}
      </div>
    </>
  );
};

export default ChartCapitalStructure;

// style={{ pointerEvents: 'all', width: '100%', height: '100%' }}
